/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const MasAddPharmacy = () => {
  const params = useParams();
  const { masAddPh, masAddPhPost } = useContext(AdminContext);
  const [selected, setSelected] = useState();
  const [mas, setMas] = useState(null);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const selectHandler = (el) => {
    setSelected(el.target.value);
  };

  const closeSuccess = () => {
    setSuccess(null);
  };

  const submitHandler = (el) => {
    el.preventDefault();
    setSuccess(null);
    masAddPhPost(mas.mas.id, selected).then((res) => {
      if (res.status === 200) {
        setMas(null);
        setSuccess(res.data);
        masAddPh(params.masId).then((res) => {
          if (res.status === 200) {
            setSelected(res.data.pharmacies[0].id);
            return setMas(res.data);
          }

          setError(res.response.data.message);
        });
      } else {
        setError(res.response.data.message);
      }
    });
  };

  useEffect(() => {
    masAddPh(params.masId).then((res) => {
      if (res.status === 200) {
        setSelected(res.data.pharmacies[0].id);
        document.title =
          "Добавить аптеку МАС'у " +
          res.data.mas.surname +
          " " +
          res.data.mas.name;
        return setMas(res.data);
      }

      setError(res.response.data.message);
    });
  }, []);
  return (
    <section className="login">
      <div className="container">
        <div className="admin__user">
          <ButtonBack count={2} />
        </div>

        {!error && !mas ? (
          <div style={{ position: "relative", minHeight: 120 }}>
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          </div>
        ) : error ? (
          <ErrorMessage message={error} />
        ) : (
          <>
            <h1 className="login__text">
              Добавить аптеку МАС'у {mas.mas.surname} {mas.mas.name}.
            </h1>

            <div className="login__wrapper">
              <form className="login__form" onSubmit={submitHandler}>
                <div className="login__item">
                  <label htmlFor="num_ap">Номер аптеки:</label>
                  <select
                    id="num_ap"
                    name="phId"
                    className="login__input"
                    onChange={selectHandler}
                    required
                  >
                    {mas.pharmacies.map((ph) => (
                      <option value={ph.id} key={ph.id}>
                        {ph.num}
                      </option>
                    ))}
                  </select>
                </div>

                <button
                  className="login__wrapper__link"
                  style={{ fontSize: 29 }}
                >
                  Сохранить
                </button>
              </form>
            </div>
          </>
        )}
      </div>
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </section>
  );
};

export default MasAddPharmacy;
